import React from 'react';
import { useHistory } from 'react-router-dom';


function WalletDetails(props) {
    const history = useHistory()

    const policies = [
        {
          policyName: "Comprehensive Car Insurance",
          underwriter: "Apex Insurance Co.",
          amount: 15000,
          policyID: "12992432"
        },
        {
          policyName: "Homeowners Protection Plan",
          underwriter: "ShieldGuard Ltd.",
          amount: 32000,
          policyID: "73u0980821"
        },
        {
          policyName: "Travel Insurance Plus",
          underwriter: "GlobalSafe Inc.",
          amount: 5000,
          policyID: "808284130"
        },
        {
          policyName: "Health Secure Plan",
          underwriter: "VitalCare Assurance",
          amount: 22000,
          policyID: "770291740"
        },
        {
          policyName: "Business Liability Cover",
          underwriter: "BizSecure Underwriters",
          amount: 45000,
          policyID: "03814218904298"
        }
      ];


      const items = policies
            // .filter((obj) => {
            //     if (search == null || search === "") return true;
            //     return (
            //     obj.policyName.toLowerCase().includes(search.toLowerCase()) ||
            //     obj.underwriter.toLowerCase().includes(search.toLowerCase()) ||
            //     obj.amount.toString().includes(search)
            //     );
            // })
            // .slice(paginate.minValue, paginate.maxValue)
            .map((row) => {
                return (
                <tr key={row.policyName}>
                    <td>{row.policyName}</td>
                    <td>
                    <div className="d-block">
                        <a href="#" className="my-0 mt-1">
                        {row.underwriter}
                        </a>
                    </div>
                    </td>
                    <td>
                    <p className="mb-0">Ksh {row.amount.toLocaleString()}</p>
                    </td>
                    <td>
                    <div className="dropdown">
                        <a
                        href="#"
                        onClick={() =>  history.push(`/dashboard/account-management/wallet/view/commission/${row.policyID}`) }
                        className="btn btn-sm btn-label-primary"
                        >
                        view
                        </a>
                    </div>
                    </td>
                </tr>
                );
            });

        console.log("ITEMS 0000",items)
      
    return (
        <div>
            <h4>Commissions</h4>
            <div className="mg-b-20">
                <div
                  className="card-body pd-0 collapse show" 
                  id="customerDetails"
                >
                  <div className="table-responsive">
                    <table className="table table-hover mg-0">
                      <thead className="tx-dark tx-uppercase tx-12 tx-bold">
                        <tr className="bg-light">
                          <th className="">Policy</th>
                          <th className="">Underwriter</th>
                          <th>Amount</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>{items}</tbody>
                    </table>
                  </div>
                </div>
              </div>
        </div>
    );
}

export default WalletDetails;